export default "__VITE_ASSET__BIYiA8nW__"